import { Link } from 'react-router-dom';

export default function SafetySection() {
  const tips = [
    {
      icon: 'ri-shield-check-line',
      title: 'Verify Product Information',
      description: 'Always double-check product details and specifications before making any purchase decision.',
    },
    {
      icon: 'ri-link-unlink',
      title: 'Avoid Suspicious Links',
      description: 'Stick to verified product links and avoid clicking on unfamiliar or suspicious-looking URLs.',
    },
    {
      icon: 'ri-lock-line',
      title: 'Protect Personal Information',
      description: 'Never share sensitive personal data with unverified sellers or through unsecured channels.',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Understand Third-Party Sellers',
      description: 'Know who you are buying from. Research seller ratings and reviews before completing a purchase.',
    },
    {
      icon: 'ri-global-line',
      title: 'Follow Local Regulations',
      description: 'Be aware of your local import regulations, customs duties, and shipping policies when ordering internationally.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Keep Records',
      description: 'Save order confirmations, tracking numbers, and communication with sellers for future reference.',
    },
  ];

  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4 tracking-wide">
            SHOP SMART
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Kakobuy Spreadsheet <span className="text-primary-500">Safety Guide</span>
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Shopping online should be safe and enjoyable. Follow these essential guidelines to protect yourself while using product spreadsheets and discovering new finds.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${tip.icon} text-lg`}></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950 mb-1">{tip.title}</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">{tip.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/complete-safety-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-100 text-accent-700 rounded-lg text-sm font-semibold hover:bg-accent-200 transition-colors duration-200 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-book-open-line"></i>
            </span>
            Read Complete Safety Guide
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}